// Passwords travel as the hex SHA-256 of what was typed: the BE stores a hash of that.
export async function sha256Hex(text: string): Promise<string> {
  const digest: ArrayBuffer = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));

  return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
}
